/**
 * A generic, user-safe message for a failed data-fetch shown in the UI.
 *
 * Never render `error.message` from a Supabase/PostgREST failure directly —
 * those strings can include internal schema details (table/column names,
 * relationship hints, RLS policy names) that shouldn't be exposed to end
 * users. Callers are still expected to `console.error` the real error for
 * debugging; this only covers what's safe to put in the DOM.
 */
export const getFriendlyErrorMessage = (_error: unknown): string =>
  "We couldn't load this right now. Please try again in a moment.";
